/**
 * Formats a string, replacing placeholders with given values.
 * Example: formatString('/download/{0}/page/{1}', product.id, product.page)
 */
export function formatString(template: string, ...args: any[]): string {
	return template.replace(/\{(\d+)\}/g, (match, number) =>
		typeof args[number] !== 'undefined' ? args[number] : match
	);
}

export function jsonToSafeString(jsonString: string) {
	  return jsonString
	    .replace(/{/g, 'xxOB')    // open brace
	    .replace(/}/g, 'xxCB')    // close brace
	    .replace(/\[/g, 'xxOA')   // open array
	    .replace(/]/g, 'xxCA')    // close array
	    .replace(/"/g, 'xxQ')     // quote
	    .replace(/:/g, 'xxCL')    // colon
	    .replace(/,/g, 'xxCM')    // comma
	    .replace(/\(/g, 'xxLP')   // left paren
	    .replace(/\)/g, 'xxRP')   // right paren
	    .replace(/</g, 'xxLT')    // less than
	    .replace(/>/g, 'xxGT')    // greater than
	    .replace(/=/g, 'xxEQ')    // equals
	    .replace(/\+/g, 'xxPLUS') // plus
	    .replace(/-/g, 'xxMIN')   // minus
	    .replace(/\$/g, 'xxDOL')  // dollar
	    .replace(/%/g, 'xxPCT')   // percent
	    .replace(/&/g, 'xxAND')   // ampersand
	    .replace(/\|/g, 'xxPIPE') // pipe
	    .replace(/;/g, 'xxSCL')   // semicolon
	    .replace(/'/g, 'xxSQ')    // single quote
	    .replace(/`/g, 'xxBQ')    // backtick
	    .replace(/~/g, 'xxTIL')   // tilde
	    .replace(/!/g, 'xxEX')    // exclamation
	    .replace(/@/g, 'xxAT')    // at symbol
	    .replace(/#/g, 'xxHASH')  // hash
	    .replace(/\^/g, 'xxCAR')  // caret
	    .replace(/\*/g, 'xxAST')  // asterisk
	    .replace(/\//g, 'xxFS')  // forward slash
	    .replace(/ /g, 'xxSP');  // space
	}
